export const SELFINVOICE_SENT = "SELFINVOICE_SENT";
export const SELFINVOICE_DISCARDED = "SELFINVOICE_DISCARDED";
export const SELFINVOICE_SNOOZED = "SELFINVOICE_SNOOZED";
export const SELFINVOICE_SAVED = "SELFINVOICE_SAVED";
